import { FC } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge, BadgeSize } from "shared/components";
import type { PrescreeningResult } from "api/lead";
import { cx } from "shared/utils/classnames";
import { PRESCREENING_RESULT_CONFIG } from "./constants";

interface PrescreeningResultBadgeProps {
  result: PrescreeningResult | null | undefined;
  reason?: string | null;
  size?: BadgeSize;
  className?: string;
}

export const PrescreeningResultBadge: FC<PrescreeningResultBadgeProps> = ({
  result,
  reason,
  size = BadgeSize.SM,
  className
}) => {
  if (!result || result === "not_started")
    return <span className="text-content-1000 text-sm">-</span>;

  const config = PRESCREENING_RESULT_CONFIG[result];
  if (!config) return <span className="text-content-1000 text-sm">-</span>;

  return (
    <Badge
      variant={config.variant}
      size={size}
      className={cx("items-center", config.className, className)}
      tooltip={reason || undefined}
      leftElement={
        <HugeiconsIcon icon={config.icon} size={12} strokeWidth={3} />
      }
    >
      {config.label}
    </Badge>
  );
};
